import React from 'react';
import { Link } from 'react-router-dom';
import * as StyledPageError from './pageError.styles';
import {
	Container, Columns, Column,
	Button
} from '../base';
import { MINAR_SIDUR_URL } from '../../constants/urls';

const PageError = ({
	title = '',
	text = ''
}) => (
	<StyledPageError.Wrapper>
		<Container>
			<Columns>
				<Column tablet={8 / 12}>
					<StyledPageError.Content>
						<StyledPageError.Title>{title}</StyledPageError.Title>
						<StyledPageError.Text>{text}</StyledPageError.Text>
						<StyledPageError.ButtonWrapper>
							<Link to="/">
								<Button>Aftur á forsíðu</Button>
							</Link>
							<Link to="/lausar-ibudir">
								<Button>Skoða íbúðir</Button>
							</Link>
							<Button
									as="a"
									href={MINAR_SIDUR_URL}
									target="_blank"
									rel="noopener noreferrer">
								{'Mínar síður'}
							</Button>
						</StyledPageError.ButtonWrapper>
					</StyledPageError.Content>
				</Column>
				<Column tablet={4 / 12}>
					<StyledPageError.Image
							image="/media/3910/hverfi.png?width={width}&height={height}&mode=crop"
							tabletWidth="400"
							tabletHeight="800"
							desktopWidth="500"
							desktopHeight="700"
							retinaWidth="1000"
							retinaHeight="1400" />
				</Column>
			</Columns>
		</Container>
	</StyledPageError.Wrapper>
);

export default PageError;
